import { dmApi } from "../../app/dmApi";
import { getAuthorizationHeader, handleQueryError, handleQueryErrorAndSuccess } from "../../helpers/RtkQueryUtils";
import { serialize } from "../../helpers/Utils";

export const mixingApi = dmApi.injectEndpoints({
    endpoints: (build) => ({

        getMixingLogs: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/pasting/mixing/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['mixingLogs'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        getMixingSummary: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/pasting/mixing/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['mixingSummary'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        createMixingLog: build.mutation({
            query: (requestBody) => ({
                url: `/pasting/mixing/create`,
                method: 'POST',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['mixingLogs', 'mixingSummary' ,'pastingOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Added", "Mixing Log");
            },
        }),

        updateMixingLog: build.mutation({
            query: ({ id, requestBody }) => ({
                url: `/pasting/mixing/update/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['mixingLogs', 'mixingSummary' ,'pastingOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Mixing Log");
            },
        }),

        getPastingLogs: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/pasting/logs?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['pastingLogs'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        updatePastingLog: build.mutation({
            query: ({ id, requestBody }) => ({
                url: `/pasting/update/${id}`,
                method: 'PUT',
                headers: getAuthorizationHeader(),
                body: requestBody,
            }),
            invalidatesTags: ['pastingLogs','pastingSummary' ,'pastingOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryErrorAndSuccess(queryFulfilled, "Updated", "Pasting Log");
            },
        }),

        getPastingSummary: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/pasting/summary?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['pastingSummary'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),

        generatePastingBatchCode: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/pasting/generate-batch-code?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['generatePastingBatchCode'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),


        // ############## PASTING DASHBOARD API ###################
        getPastingOverview: build.query({
            query: (data) => {
                const paramData = serialize(data);
                return {
                    url: `/pasting/overview?${paramData}`,
                    method: 'GET',
                    headers: getAuthorizationHeader(),
                };
            },
            providesTags: ['pastingOverview'],
            async onQueryStarted(_, { queryFulfilled }) {
                await handleQueryError(queryFulfilled);
            },
        }),
    }),
});

export const {
    useGetMixingLogsQuery,
    useGetMixingSummaryQuery,
    useCreateMixingLogMutation,
    useUpdateMixingLogMutation,
    useGetPastingLogsQuery,
    useUpdatePastingLogMutation,
    useGetPastingSummaryQuery,
    useGeneratePastingBatchCodeQuery,
    useGetPastingOverviewQuery
} = mixingApi;
